
import {
  computed,
  defineComponent,
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import { AuthModule, ServicioListadoModule } from "@/store/modules";
import { useI18n } from "vue-i18n";
import Page from "@/layout/Page.vue";
import ServiciosTabla from "@/components/servicios/TablaPrestados.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "servicios-listado",
  components: { Page, ServiciosTabla },

  setup() {
    const { t } = useI18n();
    const store = useStore();
    const module = getModule(ServicioListadoModule, store);
    const authModule = getModule(AuthModule, store);
    const comarcaId = authModule.user.comarcaId;

    const error = computed(() => module.errors);

    watch(error, () => {
      if (!error.value) return;

      Swal.fire({
        text:
          t("errors." + (error.value.error.code ?? error.value.error.name)) ??
          error.value.error.name,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: t("dialogs.okButton"),
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    });

    const cargaListado = ref(false);

    onBeforeMount(async () => {
      cargaListado.value = true;
      try {
        await module.fetchServiciosPrestados(comarcaId);
      } catch (err) {
        Swal.fire({
          text: t("formularios.serviciosPrestadosListado.cargar.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        cargaListado.value = false;
      }
    });

    onMounted(() => {
      setCurrentPageBreadcrumbs(t("menu.serviciosIndividuales"), [
        t("menu.servicios"),
      ]);
    });

    return {
      serviciosListado: computed(() => module.serviciosListado),
      cargaListado,
    };
  },
});
